<script lang="ts">
  import { Button, Form, FormGroup, Input, InputGroup, InputGroupText, Label } from "sveltestrap";
  import Link from "svelte-link";
  import FeatherIcons from "svelte-feather-icon";
  import { CreateAccount, Donthaveaccount, EmailAddress, Forgotpassword, Login, Password, Rememberpassword, Signin, Signinwith, Welcomeback, href } from "../../../../../utils/Constant/Constant";
  import data from "../../../../../Data/Authentication/Authentication.json"

</script>
<Form class="theme-form login-form">
  <h4>{Login}</h4>
  <h6>{Welcomeback}</h6>
  <FormGroup>
    <Label>{EmailAddress}</Label>
    <InputGroup>
        <InputGroupText>
          <i class="icon-email"></i>
        </InputGroupText>
        <Input type="email" required placeholder="Test@gmail.com" />
    </InputGroup>
  </FormGroup>
  <FormGroup>
    <Label>{Password}</Label>
    <InputGroup>
      <InputGroupText>
        <i class="icon-lock"></i>
      </InputGroupText>
      <Input type="password" name="login[password]" required placeholder="*********" />
      <div class="show-hide">
        <span class="show"></span>
      </div>
    </InputGroup>
  </FormGroup>
  <FormGroup>
    <div class="checkbox">
      <Input id="checkbox1" type="checkbox" />
      <Label for="checkbox1">{Rememberpassword}</Label>
    </div>
    <Link class="link" href="/theme/forgetpassword">{Forgotpassword}</Link>
  </FormGroup>
  <FormGroup>
    <Button color="primary" class="btn-block" type="submit">{Signin}</Button>
  </FormGroup>
  <div class="login-social-title">                
    <h5>{Signinwith}</h5>
  </div>
  <FormGroup>
    <ul class="login-social">
      {#each data.loginSimple as LoginItem}
        <li>
          <Link href={LoginItem.src} target="_blank">
            <FeatherIcons icon={LoginItem.icon} />
          </Link>
        </li>
      {/each}
    </ul>
  </FormGroup>
  <p>{Donthaveaccount}
    <Link class="ms-2" href={href}>{CreateAccount}</Link>
  </p>
</Form>